/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-05-25 09:17:44
 * @LastEditors: linxi
 * @LastEditTime: 2025-11-19 11:02:24
 */
import { Button, Col, Modal, Popover, Row, Spin, Tabs } from 'antd'
import React, {
  ReactElement,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { TabBar } from '../../compnents/widgets/TabBar'
import styles from './AiTuning.module.css'
import { RootDispatch } from '../../app/store'
import { getAIListAsync } from './AiTuningSlice'
import { DateRangeType, getDateRange } from '../../compnents/form/DateSelect'
import { unwrapResult } from '@reduxjs/toolkit'
import { EditableList } from '../../compnents/list/EditableList'
import moment from 'moment'
import { DateTimeFormat } from '../../models/datetime'
import { Query } from './Query'
import { Columns } from './column'
import { ThemeContext } from '../../theme/ThemeContext'
import { ModelList } from './ModelList'
import { DetailModel }  from './DetailModel'
import {TriageListColumns} from "../triage/Columns";

const { TabPane } = Tabs

export const AiTuningPage = (): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const theme = useContext(ThemeContext)

  const [timeHead, timeTail] = getDateRange(DateRangeType.Today)

  const [pageLoading, setPageLoading] = useState(false)

  const [isModalVisible, setIsModalVisible] = useState<any>(false)

  const [isShowDetailModel, setIsShowDetailModel] = useState<any>(false)

  const [detailId,setDetailId] = useState<number>(0)

  const [page, setPage] = useState<any>({
    total: 0,
    items: [],
  })

  const [params, setParams] = useState<any>({
    current: 1,
    size: 10,
  })

  const getPage = () => {
    dispatch(getAIListAsync({ ...params }))
      .then(unwrapResult)
      .then((res: any) => {
        setPage({
          items: res?.records,
          total: res?.total,
        })

        setPageLoading(false)
      })
      .catch(() => {
        setPageLoading(false)
      })
  }

  useEffect(() => {
    if (params?.startTime) {
      setPageLoading(true)
      getPage()
    }
  }, [params])

  return (
    <>
      <TabBar className={styles.tabs}>
        <TabPane tab='AI业务' key='0'>
          <>
            <div className={styles.contenter}>
              <Query
                onValueChange={(v: any) => {
                  const paramData = {
                    ...params,
                    ...v,
                    current: 1,
                    startTime: v?.startTime
                      ? moment(v?.startTime)
                          ?.startOf('day')
                          .format(DateTimeFormat)
                      : moment(timeHead)?.startOf('day').format(DateTimeFormat),
                    endTime: v?.endTime
                      ? moment(v?.endTime)?.endOf('day').format(DateTimeFormat)
                      : moment(timeTail)?.endOf('day').format(DateTimeFormat),
                  }
                  setParams({
                    ...paramData,
                  })
                }}
                Configuration={() => {
                  setIsModalVisible(true)
                }}
              />
              <EditableList
                className={styles.table}
                loading={pageLoading}
                page={{
                  current: params.current,
                  size: params.size,
                  total: page.total,
                  items: page.items,
                }}

                columns={Columns((id) => {
                    setDetailId(id);
                    setIsShowDetailModel(true);
                },params.size * (params.current - 1))}
                onChangePage={(current, size) =>
                  setParams({
                    ...params,
                    current,
                    size: size || 10,
                  })
                }
              />
            </div>
          </>
        </TabPane>
      </TabBar>
      <ModelList
        visible={isModalVisible}
        onCancel={() => {
          setIsModalVisible(false)
        }}
      ></ModelList>
      <DetailModel
          id={detailId}
          visible={isShowDetailModel}
          onCancel={() => {
              setIsShowDetailModel(false)
          }}
          onOk={() => {
              setIsShowDetailModel(false)
          }}
      ></DetailModel>
      <></>
    </>
  )
}
